import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "field-tags";

export const GET_FIELD_TAGS = "getFieldTags";
export const GET_FIELD_TAG_OPTIONS = "getFieldTagOptions";
export const GET_FIELD_TAG = "getFieldTag";
export const STORE_FIELD_TAG = "storeFieldTag";
export const UPDATE_FIELD_TAG = "updateFieldTag";
export const DELETE_FIELD_TAG = "deleteFieldTag";
export const GET_FIELD_TAG_MERGE_SUGGESTIONS = "getFieldTagMergeSuggestions";
export const MERGE_FIELD_TAGS = "mergeFieldTags";

const actions = {
  [GET_FIELD_TAGS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_FIELD_TAG_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`, params)
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_FIELD_TAG](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [STORE_FIELD_TAG](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [UPDATE_FIELD_TAG](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, params.id, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [DELETE_FIELD_TAG](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },

  [GET_FIELD_TAG_MERGE_SUGGESTIONS](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${API_PATH}${PATH}/${id}/merge-suggestions`)
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },

  [MERGE_FIELD_TAGS](context, params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`${API_PATH}${PATH}/${params.target_tag_id}/merge`, {
          source_tag_ids: params.source_tag_ids,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },
};

export default {
  actions,
};
